import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=57f49466&scoped=true&"
import script from "./Forgot.vue?vue&type=script&lang=js&"
export * from "./Forgot.vue?vue&type=script&lang=js&"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=57f49466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f49466",
  null
  
)

export default component.exports